import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CoreModule } from '@alfresco/adf-core';
import { EXTENSION_DIRECTIVES } from '@alfresco/adf-extensions';
import { SharedToolbarModule } from '@adw/projects/aca-shared/src/public-api';
import { ExpandMenuComponent } from '@adw/projects/aca-content/src/lib/components/sidenav/components/expand-menu.component'; // TODO: To add to documentation

import { WkSidenavComponent } from './sidenav.component';
import { TreeViewDirectoryComponent } from './tree-view-directory/tree-view-directory.component';
import { WkSidenavHeaderComponent } from './components/wk-sidenav-header.component';
import { CustomTreeViewModule } from './custom-tree-view/custom-tree-view.module';
import { CoreExtensionsModule } from '../../extensions/core.extensions.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    CoreExtensionsModule.forChild(),
    ...EXTENSION_DIRECTIVES,
    RouterModule,
    CustomTreeViewModule,
    SharedToolbarModule,
    ExpandMenuComponent,
  ],
  declarations: [
    WkSidenavComponent,
    WkSidenavHeaderComponent,
    TreeViewDirectoryComponent,
  ],
  exports: [WkSidenavComponent, TreeViewDirectoryComponent],
})
export class WkAppSidenavModule {}
